export default __webpack_public_path__ + "static/media/0xfa68fb4628dff1028cfec22b4162fccd0d45efb6.d55a42e0.jpeg";